import React from 'react';
import { CheckCircle, XCircle, Clock } from 'lucide-react';
import { Card } from '../../SubscriptionAppCard';
interface RetryAttempt {
  id: string;
  attemptNumber: number;
  date: string;
  time: string;
  status: 'success' | 'failed' | 'pending';
  reason?: string;
  amount: string;
}
interface PaymentRetryHistoryProps {
  retryAttempts: RetryAttempt[];
}
export function PaymentRetryHistory({
  retryAttempts
}: PaymentRetryHistoryProps) {
  if (!retryAttempts || retryAttempts.length === 0) {
    return null;
  }
  const getStatusIcon = (status: 'success' | 'failed' | 'pending') => {
    switch (status) {
      case 'success':
        return <CheckCircle className="w-5 h-5 text-[#10B981]" data-id="element-5269" data-mp="n05m53clao4i" />;
      case 'failed':
        return <XCircle className="w-5 h-5 text-[#EF4444]" data-id="element-5270" data-mp="rxxic9k9owei" />;
      case 'pending':
        return <Clock className="w-5 h-5 text-[#64748B]" data-id="element-5271" data-mp="wyuw89y8v4a7" />;
    }
  };
  const getStatusText = (attempt: RetryAttempt) => {
    if (attempt.status === 'success') {
      return <span className="text-[13px] text-[#10B981]" data-id="element-5272" data-mp="p1tvoae90ymf">Success</span>;
    }
    if (attempt.status === 'pending') {
      return <span className="text-[13px] text-[#64748B]" data-id="element-5273" data-mp="k2qxn9worsny">Pending</span>;
    }
    if (attempt.status === 'failed' && attempt.reason) {
      return <span className="text-[13px] text-[#EF4444]" data-id="element-5274" data-mp="f45yzex31h1m">
          Failed - {attempt.reason}
        </span>;
    }
    return <span className="text-[13px] text-[#EF4444]" data-id="element-5275" data-mp="a6xayxp96isg">Failed</span>;
  };
  return <Card padding="none" data-id="element-5276" data-mp="17s1sybv9ouup">
      <div className="p-6 border-b border-[#E2E8F0] bg-gradient-to-r from-[#F8FAFC] to-white" data-id="element-5277" data-mp="17uflacykbsyk">
        <h3 className="text-[20px] font-semibold text-[#0F172A]" data-id="element-5278" data-mp="12vl2vc4ic6ez">
          Payment Retry History
        </h3>
      </div>

      <div className="p-6 bg-white" data-id="element-5279" data-mp="t3ykmvtr572q">
        <div className="space-y-4" data-id="element-5280" data-mp="t2x96q8tqikh">
          {retryAttempts.map((attempt, index) => <div key={attempt.id} className="relative" data-id="element-5281" data-mp="1qjm9ugm1fesa" data-mpi={index}>
              {/* Connector line */}
              {index < retryAttempts.length - 1 && <div className="absolute left-[10px] top-[28px] bottom-[-16px] w-[2px] bg-[#E2E8F0]" data-id="element-5282" data-mp="1lrkq69mjils8" />}

              {/* Timeline item */}
              <div className="flex items-start gap-4" data-id="element-5283" data-mp="3g2ki2pc7bblk">
                {/* Status icon */}
                <div className="flex-shrink-0 relative z-10 bg-white" data-id="element-5284" data-mp="3l143momvulde">
                  {getStatusIcon(attempt.status)}
                </div>

                {/* Details */}
                <div className="flex-1 min-w-0" data-id="element-5285" data-mp="3b7wx30geozbq">
                  <div className="flex items-baseline justify-between gap-4" data-id="element-5286" data-mp="2x973hussphs4">
                    <div data-id="element-5287" data-mp="31bbusmvru2bl">
                      <div className="text-[14px] font-medium text-[#0F172A]" data-id="element-5288" data-mp="31btqnieiueiz">
                        {attempt.attemptNumber === 0 ? 'Initial Payment' : `Retry ${attempt.attemptNumber}`}
                        {attempt.status === 'pending' && ' (Scheduled)'}
                      </div>
                      <div className="text-[13px] text-[#64748B] mt-0.5" data-id="element-5289" data-mp="lkfmtjfun9a3">
                        {attempt.date} at {attempt.time}
                      </div>
                      <div className="mt-1" data-id="element-5290" data-mp="qihbcjw1o0sy">{getStatusText(attempt)}</div>
                    </div>

                    {/* Amount */}
                    {attempt.amount && attempt.status !== 'pending' && <div className="text-[14px] font-medium text-[#0F172A] flex-shrink-0" data-id="element-5291" data-mp="263rsccnt988t">
                        {attempt.amount}
                      </div>}
                  </div>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </Card>;
}